import _ from "lodash";

import {
  KEY_DEVICE_MANAGEMENT_CUSTOMERS,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS_ADD,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS_DELETE,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS_UPDATE,
  KEY_DEVICE_MANAGEMENT_PROJECT_ADD,
  KEY_DEVICE_MANAGEMENT_PROJECT_DELETE,
  KEY_DEVICE_MANAGEMENT_PROJECT_UPDATE,
} from "@static/PERMISSION_KEY";

const BLOCK_PERMISSION_CUSTOMER = [
  KEY_DEVICE_MANAGEMENT_CUSTOMERS,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS_ADD,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS_UPDATE,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS_DELETE,
  KEY_DEVICE_MANAGEMENT_PROJECT_ADD,
  KEY_DEVICE_MANAGEMENT_PROJECT_UPDATE,
  KEY_DEVICE_MANAGEMENT_PROJECT_DELETE,
];

export const filterPermissions = ({ permissions, userType }) => {
  if (userType !== "CUSTOMER") {
    return permissions;
  }

  const filterChildren = ({ permissions }) => {
    return _.map(permissions, (item) => {
      const children = _.get(item, "children");
      if (children) {
        return {
          ...item,
          children: filterChildren({
            permissions: _.filter(children, (child) => {
              const key = _.get(child, "key");
              return !_.includes(BLOCK_PERMISSION_CUSTOMER, key);
            }),
          }),
        };
      }
      return item;
    });
  };

  return filterChildren({ permissions });
};
